module.exports = __webpack_public_path__ + "img/nov.a96055a3.png";